export default __webpack_public_path__ + "static/media/wifi-solid.bdfe4afa.svg";